export default "__VITE_ASSET__D0icx$PD__"